
import { CricketBowlingBase } from './Cricket-Bowling-Base';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleArrowDown, faTabletAlt, faLaptop, faRedo } from '@fortawesome/free-solid-svg-icons'
import LandingHeader from '../LandingHeader';

export const CricketBowlingThrowing = () => {
    const sportKey = "cricket";
    return (<CricketBowlingBase 
                banner={<><LandingHeader sportKey={sportKey} headline="Bowl with a straight arm in no time" subHeading="" images={[
                                                    {src: "./assets/img/cricket/bowling/elbow_angle_2.png", caption: "Measure elbow angle", captionTop: '57%'}
                                                ]} />
                                                
                                         <section className="atf-section-padding">
                        <div className="container">
                            <div className="row justify-content-center clearfix">
                                <div className="col-lg-7 col-12  text-center align-self-center">
                                    <div>
                                        <h2 style={{ fontSize: '30px', marginTop: "5px", marginBottom: "10px", lineHeight: "1.5", color:"yellowgreen"}}>Instant replay.<br /><span style={{color:'var(--thm-black)'}}>With elbow analysis.</span><br /><span style={{color:'#999999'}}>After every bowl.</span></h2>
                                        
                                        <p style={{ fontSize: "18px", margin: "5px 0 20px 0" }}>Real-time feedback to<br/><strong>Watch, Learn,</strong> and <strong>improve</strong> after each delivery.</p>
                                    </div>
                                </div>
                                <div className="col-lg-5 col-10 text-center">
                                    
                                <img src="./assets/img/cricket/bowling/green_red_elbow_angle_compare.png" alt="Elbow angle" />
                                            <p style={{ fontSize: "16px", margin: "15px 0 20px 0" }}>Set the "green or red" range, based on skill level.</p>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="atf-section-padding" style={{background: 'yellowgreen'}}>
                        <div className="container">
                            <div className="row justify-content-center clearfix">
                                <div className="col-12  text-center align-self-center">
                                    <div>
                                        <h2 style={{ fontSize: '28px', lineHeight: "1.3", color: "white" }}>Don't practice the wrong action</h2>
                              
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="atf-section-padding">
                        <div className="container">
                            <div className="row justify-content-center clearfix">
                                <div className="col-lg-7 col-12  text-center align-self-center">
                                    <div>
                                        <h2 style={{ fontSize: '30px', marginTop: "5px", marginBottom: "10px", lineHeight: "1.5", color:"var(--thm-black)"}}><span style={{color: 'yellowgreen'}}>Real time feedback,</span><br/>for real fast improvement</h2>
                                        
                                        <p style={{ fontSize: "18px", margin: "15px 0 0px 0" }}>All kids <strong>think</strong> they are bowling correctly.</p>
                                        <p style={{ fontSize: "18px", margin: "5px 0 20px 0" }}>PracticeLoop <strong>shows</strong> them what they are <strong>really</strong> doing so they can self-improve quickly.</p>
                                    </div>
                                </div>
                                <div className="col-lg-5 col-9 text-center">
                                    <video controls loop width={"100%"} style={{marginTop: '20px'}} poster="./assets/img/cricket/bowling/arm_angle_3.png">
                                                <source src="/assets/img/cricket/bowling/bowling_video.mp4" type="video/mp4" />
                                            </video>

                                </div>
                            </div>
                        </div>
                    </section>          

                    <section className="atf-section-padding">
                        <div className="container">
                            <div className="row justify-content-center clearfix">
                                <div className="col-12  text-center align-self-center">
                                    <div>
                                        <h2 style={{ fontSize: '30px', marginTop: "5px", marginBottom: "10px", lineHeight: "1.5", color:"var(--thm-black)"}}>Not just for straight arms</h2>
                                        <p style={{ fontSize: "18px", margin: "15px 0 20px 0" }}>See why PracticeLoop is the best way to improve any part of your action</p>
                                        <FontAwesomeIcon icon={faCircleArrowDown} style={{color: 'yellowgreen', fontSize: '60px'}} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>  
          </>} />
    
    );
}

export default CricketBowlingThrowing;